import { SiteSettings } from 'lib/page-props-factory/plugins/site-settings';
import { Data } from '@generated/Foundation.GMI.model';
import { RecipeSeoProps } from './RecipeSeo';

/**
 * Extracts FAQ data from a RecipeResponse object
 * @param recipe - The full recipe response object
 * @param siteSettings - Optional site settings for recipe FAQ settings
 * @returns RecipeFAQProps object with only the properties needed for the recipe header
 */
export function extractRecipeSeoContentData(
  siteSettings?:
    | (SiteSettings & {
        recipeDetailSiteSettings?: Data.Settings.RecipeDetailSiteSettings;
      })
    | null
): RecipeSeoProps {
  const { recipeDetailSiteSettings } = siteSettings || {};
  const seoContentSettings = {
    hideSEOContent: recipeDetailSiteSettings?.fields?.hideRecipeSeoContent?.value,
  };
  return {
    seoContentSettings: {
      ...seoContentSettings,
    },
  };
}
